<template>
  <CCard>
    <CCardBody class="mb-3">
      <CCardHeader>
        <CRow>
          <CCol col="8" style="text-align: start">

            <strong>{{ $t('ReceiptList') }}</strong>

          </CCol>
          <CCol col="4" style="text-align: end">

          </CCol>
        </CRow>
        <!--        </div>-->

        <!-- Right aligned nav items -->
        <!--      </CCollapse>-->
      </CCardHeader>
      <CRow>
        <CCol col="3">
          <date-picker
              :label="$t('components.startDate')"
              v-model="start_date"></date-picker>
        </CCol>
        <CCol col="3">
          <date-picker
              :label="$t('components.endDate')"
              v-model="end_date"></date-picker>

        </CCol>
        <CCol col="3">
          <CSelect
              :options="cashiers"
              :value.sync="selected_cashier"
              />

        </CCol>
        <CCol col="1">
          <CButton @click="get_receive_list" color="dark"
                   size="sm">
            <CIcon size="sm" name="cil-zoom"/>
          </CButton>
        </CCol>
      </CRow>
      <CDataTableFixed
          :items="items_filtered"
          :fields="fields"
          striped
          :sorter-value="{column:'docDate',asc:false}"

          border
          column-filter
          :items-per-page="200"
          hover
          sorter
          pagination
          @row-clicked="table_row_clicked"

      >


        <template #row="{item,index}">

          <td style="text-align: center">
            <p>{{ index + 1 }}</p>

          </td>

        </template>
        <template #docDate="{item}">
          <td>
            <p style="text-align: center">{{ get_date(item.docDate) }}</p>
          </td>
        </template>
        <template #recCode="{item}">
          <td>
            <p style="text-align: center">{{ (item.recCode) }}</p>
          </td>
        </template>
        <template #cashPaymentCode="{item}">
          <td>
            <p style="text-align: center"  v-c-tooltip="item.payDesc ? {
        content: item.payDesc,
        placement: 'bottom-start'
      } : ''">
              {{ (item.cashPaymentCode) }}</p>
          </td>
        </template>
        <template #amount="{item}">
          <td>
            <p style="float: right">{{ get_currency(parseFloat(item.amount)) }}</p>
          </td>
        </template>

        <template #docNo="{item}">
          <td>
            <p style="text-align: center" >
              <a :href="'/dashboard/accounting/show-accounting-doc/'+item.docNoId" target="_blank">
                {{ item.docNo }}
              </a>
            </p>
          </td>
        </template>
        <template #payDesc="{item}">
          <td>
            <p v-if="item.payDesc!=null">{{ item.payDesc }}</p>
          </td>
        </template>
        <template #masterCode="{item}">
          <td>
            <p v-if="item.masterCode!=null">{{ item.masterCode }}</p>
          </td>
        </template>

        <template #under-table="{item}">
          <CRow>

            <CCol>

            </CCol>
            <CCol>

            </CCol>
            <CCol>

            </CCol>
            <CCol>

            </CCol>
            <CCol>
              {{ $t('totalSum') }} :{{ get_currency(calculate_items(items_filtered, "amount")) }}
            </CCol>
            <CCol>

            </CCol>
          </CRow>
        </template>

      </CDataTableFixed>

      <CModal
          :show.sync="show_factor_detail"
          :no-close-on-backdrop="true"
          :centered="true"
          :title="$t('InventoryBill')"

          color="dark"
      >
        <CCard id="printMe">
          <ShowPayReceiveDocs :doc_id="selected_doc_id"/>

        </CCard>


        <template #footer>

          <CButton
              @click="show_factor_detail = false"
              color="success"
          >{{ $t("buttons.close") }}
          </CButton>
        </template>
      </CModal>

    </CCardBody>

  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import Vue from "vue";
import ShowPayReceiveDocs from "../accounting/ShowPayReceiveDocs";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
export default {
  name: 'ReceiveOperation',

  components: {
    Treeselect,
    BTabs,
    ShowPayReceiveDocs,
  },

  data() {
    var self = this;

    return {
      show_factor_detail: false,
      selected_doc_id: null,
      table_clicks_timer: null,
      table_clicks: 0,
items_filtered:[],
      start_date: '',
      end_date: '',
      selected_master_type: 130,
      search_reference_master: 0,
      selected_doc_type: 2,
      selected_receiver_cash: 0,
      document_person_cash: null,
      searched_refrences: [],
      get_items: [1],
      master_id: null,
      master_types: [{id: 130, label: this.$t('Customers')}, {id: 132, label: this.$t('debtors')}, {
        id: 142,
        label: this.$t('persons')
      }, {id: 141, label: this.$t('FlowEmployee')}, {id: 140, label: this.$t('EmployeeLoans')}],
      active_tab: 0,
      date_cash: '',
      summary: '',

      selected_payer_cash: null,
      doc_types: [
        {value: 2, label: this.$t('components.cash')},
        {
          value: 6, label: this.$t('components.bank')
        }, {value: 1, label: this.$t('components.pos')}],
      status_form: 0,
      price: '',
      bank_names: [],
      searched_person: [],
      document_person: null,
      search_user_async: true,
      pay_for_detail: null,
      // search_detail_async

      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'docDate', label: this.$t('date'), _style: 'padding:0px'},

        {key: 'cashPaymentCode', label: this.$t('receiveCode'), _style: 'padding:0px'},
        {key: 'docNo', label: this.$t('docNumber'), _style: 'padding:0px'},
        {key: 'partyName', label: this.$t('tables.customer'), _style: 'padding:0px'},
        {key: 'masterCode', label: this.$t('reference'), _style: 'padding:0px'},


        {key: 'amount', label: this.$t('tables.amount'), _style: 'padding:0px'},

        {key: 'cashierName', label: this.$t('tables.bankAccTitle'), _style: 'padding:0px'},
        {key: 'payerName', label: this.$t('components.payer'), _style: 'padding:0px'},
        // {key: 'paymentTypeTitle', label: this.$t('tables.payType'), _style: 'padding:0px'},
        // {key: 'payDesc', label: this.$t('description'), _style: 'padding:0px'},
      ],
      items: [],

      cashiers:[],
      selected_cashier:0,
      document_person_cheque: null,
      selected_receiver_cheque: null,
      summary_cheque: "",

    }
  }, mounted() {
    this.date_cash = this.get_today();
    this.date_cheque = this.get_today();
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML

this.get_cashiers()
    this.get_receive_list();
    bus.$on("update_add_receive", (data) => {
      // alert(data);
      this.get_receive_list();

    });

    if (this.$route.params.product_id != null) {
      this.editable = true;
      this.status_form = this.$route.params.product_id;
      this.get_product_data();
    }
  }, watch: {
    'selected_cashier': function () {
      if(this.selected_cashier==0){
        this.items_filtered = this.items;
      }else{
        this.items_filtered = this.items.filter(x=>x.cashierId==this.selected_cashier)
      }
    }
  },
  computed: {},
  methods: {
// 222800 16 3 26 4
    table_row_clicked(item, index) {
      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        console.log("clicked")

        this.table_clicks = 0
        this.show_factor_detail = true
        this.selected_doc_id = item.recId
      }

    },
    get_receive_list() {
      var self = this;

      const formData = new FormData();


      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);


      axios.post('GetCashPaymentList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          content_data.data.reverse()
          content_data.data.forEach(function (val){
            if(val.payDesc==null){
              val.payDesc = " "
            }
          })
          self.items = content_data.data.filter(item => parseFloat(item.amount) > 0);

          self.items = self.items.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_filtered = self.items
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_banks() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.cashiers= self.sort_array(self.cashiers,
          //     content_data.data,
          //     'id','bankAccTitle')
          self.get_terminals()
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);
      self.cashiers=[{label: this.$t('all'), value: 0}]

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.cashiers=self.sort_array(self.cashiers,
              content_data.data.filter(x => x.accountId == 70),
          'id','boxTitle');

          self.get_banks()

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_terminals() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankTerminals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers= self.sort_array(self.cashiers,
              content_data.data,
              'id','terminalTitle')
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
  }
}

</script>
